var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Logo'),_c('h1',[_vm._v("Witaj w kreatorze do personalizacji")]),_c('p',[_vm._v(" Poniżej możesz zobaczyć wszystkie projekty dostępne do samodzielnej personalizacji przy pomocy kreatora. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }